import { CriticaRegistroBoletoModule } from './main/content/critica-registro-boleto/critica-registro-boleto.module';
import { IntegracaoBancariaModule } from './main/content/integracaobancaria/integracaobancaria.module';
import { AreaRestritaModule } from './main/content/arearestrita/arearestrita.module';
import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerModule, MatFormFieldModule, MatInputModule, MatOptionModule, MatRadioModule, MatSelectModule } from '@angular/material';
import { MatPaginatorModule } from '@angular/material/paginator'
import 'hammerjs';
import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';
import { fuseConfig } from 'app/fuse-config';
import { MainModule } from 'app/main/main.module';
import { DashboardModule } from 'app/main/content/dashboard/dashboard.module';
import { MenuselectModule } from './main/content/menuselect/menuselect.module';
import { EsteiraModule } from './main/content/esteira/esteira.module';
import { NotfoundModule } from './main/content/notfound/notfound.module';
import { LoginModule } from './login/login.module';
import { DetalhesModule } from './main/content/detalhes/detalhes.module';
import { DialogModule } from './main/content/message/dialog.module';
import { JwtInterceptor } from './main/content/shared/helper/jwt.interceptor';
import { LoginStore } from './main/content/shared/store/login.store';
import { AppComponent } from 'app/app.component';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { MAT_DATE_LOCALE } from '@angular/material';
import { NotificacoesModule } from './main/content/notificacoes/notificacoes.module';
import { AreaInterativaModule } from './main/content/areainterativa/areainterativa.module';
import { InsertDialogComponent } from './main/content/arearestrita/configdashboard/dialogs/insert/insert.dialog.component';
import { EditDialogComponent } from './main/content/arearestrita/configdashboard/dialogs/edit/edit.dialog.component';
import { DeleteDialogComponent } from './main/content/arearestrita/configdashboard/dialogs/delete/delete.dialog.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { EditDialogFornecedorComponent } from './main/content/arearestrita/configfornecedores/dialogs/edit/edit.dialog.component';
import { InsertDialogFornecedorComponent } from './main/content/arearestrita/configfornecedores/dialogs/insert/insert.dialog.component';
import { DeleteDialogFornecedorComponent } from './main/content/arearestrita/configfornecedores/dialogs/delete/delete.dialog.component';
import { DeleteDialogAtasComponent } from './main/content/arearestrita/configatas/dialogs/delete/delete.dialog.component';
import { InsertDialogAtasComponent } from './main/content/arearestrita/configatas/dialogs/insert/insert.dialog.component';
import { EditDialogAtasComponent } from './main/content/arearestrita/configatas/dialogs/edit/edit.dialog.component';
import { DeleteDialogFuncionalidadesComponent } from './main/content/arearestrita/configfuncionalidades/dialogs/delete/delete.dialog.component';
import { InsertDialogFuncionalidadesComponent } from './main/content/arearestrita/configfuncionalidades/dialogs/insert/insert.dialog.component';
import { ModalComponent } from './main/content/arearestrita/notificacaoparticipante/dialogs/modal/modal.dialog.component';
import { DetalhesEmprestimoModule } from './main/content/detalhes/detalhes-emprestimo/detalhes-emprestimo.module';
import { RelatorioCobrancaModule } from './main/content/relatorio-cobranca/relatorio-cobranca.module';
import { DetalhesCobrancaModule } from './main/content/relatorio-cobranca/detalhes-cobranca/detalhes-cobranca.module';
import { ConfigFuncionalidadeModule } from './main/content/arearestrita/config-funcionalidade/config-funcionalidade.module';
import { InsertDialogFuncionalidadeComponent } from './main/content/arearestrita/config-funcionalidade/dialogs/insert/insert.dialog.component';
import { NgxLoadingModule } from "ngx-loading";
import { DeleteDialogFuncionalidadeComponent } from './main/content/arearestrita/config-funcionalidade/dialogs/delete/delete.dialog.component';
import { InsertDialogMensagemFuncionalidadeComponent } from './main/content/arearestrita/config-mensagem-funcionalidade/dialogs/insert/insert.dialog.component';
import { EditDialogMensagemFuncionalidadeComponent } from './main/content/arearestrita/config-mensagem-funcionalidade/dialogs/edit/edit.dialog.component';
import { DeleteDialogMensagemFuncionalidadeComponent } from './main/content/arearestrita/config-mensagem-funcionalidade/dialogs/delete/delete.dialog.component';
import { EnviarEmailModule } from './main/content/enviar-email/enviar-email.module';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { CadastrarMensagemModuloComponent } from './main/content/arearestrita/cadastrar-mensagem-modulo/cadastrar-mensagem-modulo/cadastrar-mensagem-modulo.component';
import { CadastrarMensagemModuloModule } from './main/content/arearestrita/cadastrar-mensagem-modulo/cadastrar-mensagem-modulo/cadastrar-mensagem-modulo.module';
import { ModalMensagemModule } from './main/content/arearestrita/cadastrar-mensagem-modulo/modal-mensagem/modal-mensagem/modal-mensagem.module';
import { ModalMensagemComponent } from './main/content/arearestrita/cadastrar-mensagem-modulo/modal-mensagem/modal-mensagem/modal-mensagem.component';
import { DetalhesComponent } from './main/content/detalhes/detalhes.component';
import { MensageriaIntegracaoBancariaModule } from './main/content/mensageria-integracaobancaria/mensageria-integracaobancaria.module';
import { MensageriaRelatorioCobrancaComErroModule } from './main/content/mensageria-relatoriocobrancacomerro/mensageria-relatoriocobrancacomerro.module';
import { MensageriaRelatorioCobrancaComErroComponent } from './main/content/mensageria-relatoriocobrancacomerro/mensageria-relatoriocobrancacomerro.component';
import { GestorFinanceiroComponent } from './main/GestorFinanceiro/GestorFinanceiro.component';
import { GestorFinanceiroModule } from './main/GestorFinanceiro/GestorFinanceiro.componet.module';
import { ModalBeneficiarioDetalhesComponent } from './main/content/detalhes/modal-beneficiario-detalhes/modal-beneficiario-detalhes.component';
import { ModalBeneficiarioDetalhesModule } from './main/content/detalhes/modal-beneficiario-detalhes/modal-beneficiario-detalhes.module';
import { MensagemExcecaoModule } from './main/content/arearestrita/mensagem-excecao/mensagem-excecao.module';
import { ModalCadastroExcecaoModule } from './main/content/arearestrita/mensagem-excecao/modal-cadastro-excecao/modal-cadastro-excecao.module';
import { ModalCadastroExcecaoComponent } from './main/content/arearestrita/mensagem-excecao/modal-cadastro-excecao/modal-cadastro-excecao.component';
import { MensagemExcecaoComponent } from './main/content/arearestrita/mensagem-excecao/mensagem-excecao.component';

const appRoutes: Routes = [
    {
        path: ' ',
        redirectTo: 'login'
    }
];

registerLocaleData(localePt);


@NgModule({
    declarations: [
        AppComponent,
        InsertDialogComponent,
        EditDialogComponent,
        DeleteDialogComponent,
        EditDialogFornecedorComponent,
        InsertDialogFornecedorComponent,
        DeleteDialogFornecedorComponent,
        EditDialogAtasComponent,
        InsertDialogAtasComponent,
        DeleteDialogAtasComponent,
        InsertDialogFuncionalidadesComponent,
        DeleteDialogFuncionalidadesComponent,
        InsertDialogFuncionalidadeComponent,
        InsertDialogMensagemFuncionalidadeComponent,
        EditDialogMensagemFuncionalidadeComponent,
        DeleteDialogFuncionalidadeComponent,
        DeleteDialogMensagemFuncionalidadeComponent,
        ModalComponent,
        ModalMensagemComponent,
        ModalBeneficiarioDetalhesComponent

       // DetalhesComponent,
        
              
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes),
        TranslateModule.forRoot(),

        //Color Picker Module
        ColorPickerModule,


        // Material moment date module
        MatMomentDateModule,

        // Material
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        MatFormFieldModule,
        MatPaginatorModule,
        MatTableModule,
        MatSelectModule,
        MatOptionModule,
        NgxLoadingModule,
        MatDatepickerModule,
        MatRadioModule,
        MatTableModule,
        
        

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,

        // App modules
        MainModule,
        DashboardModule,
        MenuselectModule,
        EsteiraModule,
        DetalhesEmprestimoModule,
        NotfoundModule,
        LoginModule,
        DetalhesModule,
        DialogModule,
        AreaInterativaModule,
        AreaRestritaModule,
        NotificacoesModule,
        IntegracaoBancariaModule,
        MensageriaIntegracaoBancariaModule,
        MensageriaRelatorioCobrancaComErroModule,
        CriticaRegistroBoletoModule,
        RelatorioCobrancaModule,
        DetalhesCobrancaModule,
        EnviarEmailModule,
        CadastrarMensagemModuloModule,
        GestorFinanceiroModule,
        MensagemExcecaoModule,
       
       
        //ConfigFuncionalidadeModule

    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        LoginStore
    ],

    bootstrap: [
        AppComponent
    ],

    entryComponents: [
        InsertDialogComponent,
        EditDialogComponent,
        DeleteDialogComponent,
        EditDialogFornecedorComponent,
        InsertDialogFornecedorComponent,
        DeleteDialogFornecedorComponent,
        EditDialogAtasComponent,
        InsertDialogAtasComponent,
        DeleteDialogAtasComponent,
        InsertDialogFuncionalidadesComponent,
        InsertDialogFuncionalidadeComponent,
        InsertDialogMensagemFuncionalidadeComponent,
        EditDialogMensagemFuncionalidadeComponent,
        DeleteDialogFuncionalidadesComponent,
        DeleteDialogFuncionalidadeComponent,
        DeleteDialogMensagemFuncionalidadeComponent,
        ModalComponent,
        ModalMensagemComponent,
        DetalhesComponent,
        MensageriaRelatorioCobrancaComErroComponent,
        ModalBeneficiarioDetalhesComponent

    ]
})
export class AppModule {
}
